import React from 'react';
import PropTypes from 'prop-types';

import FreemiumEventDetails from '../../../FreemiumEvents/FreemiumEventDetails';
import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import { isSingleEventItemConfigByType } from '../../util';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../constants/event-items';
import { EVENT_DETAILS_CONTEXT } from '../../../FreemiumEvents/FreemiumEventDetails/utils';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object,
  stepProps: PropTypes.shape({
    eventType: PropTypes.string,
    purchasedEventAddonItemFeatures: PropTypes.object,
  }),
};

const FreemiumEventCreateDetailsStep = ({
  user,
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
  stepProps,
}) => {
  const { isEveryDayShare } = stepProps;
  const context =
    !stepProps?.requiresSKUSelection &&
    // Requested by Ops that this works for LSS and MSS
    isSingleEventItemConfigByType(
      stepProps?.eventAddonItems,
      stepProps?.currentSelectedEventAddonItemIds,
      EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK,
    )
      ? EVENT_DETAILS_CONTEXT.SLIDESHOW
      : EVENT_DETAILS_CONTEXT.EVENT;

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <FreemiumEventDetails
          user={user}
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          eventType={stepProps.eventType}
          purchasedEventAddonItemFeatures={
            stepProps.purchasedEventAddonItemFeatures
          }
          requireAccountEmail={stepProps.requireAccountEmail}
          requireCouplesEmail={stepProps.requireCouplesEmail}
          context={context}
          includeCelebrated={!isEveryDayShare}
        />
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateDetailsStep.propTypes = propTypes;

export default FreemiumEventCreateDetailsStep;
